import dataStorageManager, { BucketDefaultIDs, DMS_Operation } from '../../managers/data/DataStorageManager'
import dataQueryManager from '../../managers/network/DataQueryManager'
import { IArmador } from './ArmadoresServices'
import { IEmbarcacion } from './EmbarcacionesServices'
import { IRequest } from './RequestsServices'
import { IService } from './ServicesServices'
import { IViaje } from './ViajesServices'

export enum CobroMuelle {
  ESTE = 'ESTE',
  WESTE = 'WESTE',
}

export enum CobroEstado {
  PENDIENTE = 0,
  PAGADO = 1,
  RECHAZADO = 2,
}

export interface ICobro {
  id: number
  fecha: string
  muelle: CobroMuelle
  codigo_sap: number
  valor_aplicado: number
  unidades_aplicadas: number
  fecha_registro: string
  usuario_registro: number
  observaciones: string | null
  estado: CobroEstado
  id_armador: number
  id_embarcacion: number
  valor_total: number
}

export interface ICompleteCobro extends ICobro, IEmbarcacion, IArmador {}

export interface OperatedCobro extends ICobro {
  cobrosRequests: Array<IRequest>
  viajesApplied: Array<IViaje>
  servicesApplied: Array<IService>
}

export const defaultICobro: ICobro = {
  id: 0,
  fecha: new Date().toISOString(),
  muelle: CobroMuelle.ESTE,
  codigo_sap: 0,
  valor_aplicado: 0,
  unidades_aplicadas: 0,
  fecha_registro: new Date().toISOString(),
  usuario_registro: 0,
  observaciones: null,
  estado: 0,
  id_armador: 0,
  id_embarcacion: 0,
  valor_total: 0,
}

export default class CobrosServices {
  private bucketID: string | null = null

  constructor() {
    // Registrar el bucket para armadores
    this.bucketID = dataStorageManager.registerBucket<ICompleteCobro>(
      this.getAllCobros.bind(this), // Asegúrate de enlazar el contexto correcto
      {
        refreshRatio: 5 * 60 * 1000, // Refrescar cada 5 minutos
        //preload: true, // Preload
        bucketID: BucketDefaultIDs.COBROS, // ID del bucket
        operations: new Map<string, DMS_Operation>([
          [
            'insertCobro',
            {
              operation: this.insertCobro.bind(this),
              reloadAfter: true,
            },
          ],
        ]), // Las operaciones se añadiran despues
      },
    )
  }

  startup() {}

  private async getAllCobros(): Promise<ICompleteCobro[]> {
    try {
      const response = await dataQueryManager.addQuery<ICompleteCobro | ICompleteCobro[]>({
        query: `${import.meta.env.VITE_BASE_URL}/finanzas/1/op_select_historial_cobro`,
        operation: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        params: [],
      })
      if (response.data && Array.isArray(response.data)) {
        return response.data
      } else if (response.data) {
        if (response.data) {
          return [response.data]
        }
      }
    } catch (error) {
      console.error('Error fetching cobros:', error)
    }
    return []
  }

  async insertCobro(cobroData: Omit<ICobro, 'id' | 'fecha_registro' | 'estado'>): Promise<ICobro | null> {
    try {
      const body = {
        op_crear_historial_cobro: {
          p_fecha: cobroData.fecha,
          p_muelle: cobroData.muelle,
          p_codigo_sap: cobroData.codigo_sap,
          p_id_armador: cobroData.id_armador,
          p_id_embarcacion: cobroData.id_embarcacion,
          p_valor_aplicado: cobroData.valor_aplicado,
          p_unidades_aplicadas: cobroData.unidades_aplicadas,
          p_usuario_registro: cobroData.usuario_registro,
          p_valor_total: cobroData.valor_total,
          p_observaciones: cobroData.observaciones,
        },
      }
      const response = await dataQueryManager.addQuery<ICobro>({
        query: `${import.meta.env.VITE_BASE_URL}/finanzas/1/op_crear_historial_cobro`,
        operation: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        params: [],
        body: body,
      })
      console.log('Response insertCobro:', response)
      if (response.data) {
        return response.data as ICobro
      }
    } catch (error) {
      console.error('Error inserting cobro:', error)
    }
    return null
  }
}
